import type { Translate } from "../text";

/** Field issues by path without the `body.` prefix (`name.en`, `qualifications.0.title.en`), each a stable code. */
export type FieldIssues = Readonly<Record<string, string>>;

const CODES = new Set([
  "REQUIRED",
  "TOO_LONG",
  "LENGTH",
  "INVALID_SLUG",
  "RESERVED",
  "TAKEN",
  "DUPLICATE",
  "NOT_A_CLEAN_LOGO_OF_THIS_SHOP",
  "NOT_A_CLEAN_DOCUMENT_OF_THIS_SHOP",
  "TOO_MANY",
  "NOT_FOR_SERVICES",
  "NOT_FOR_GOODS",
  "INVALID_TYPE",
  "OUT_OF_RANGE",
  "NOT_INTEGER",
  "UNKNOWN_OPTION",
  "UNKNOWN_ATTRIBUTE",
  "NOT_FOUND",
  "NOT_A_LEAF",
  "RETIRED",
  "OTHER_KIND",
  "INVALID_QUANTITY",
  "INVALID_PRICE",
  "CURRENCY_NOT_ENABLED",
  "FIRST_TIER_NOT_MOQ",
  "NOT_RISING",
  "PRICE_RISES",
  "MIXED_CURRENCIES",
  "NOT_FOR_INQUIRY_ONLY",
  "INVALID_HS_CODE",
  "INVALID_COUNTRY",
  "INVALID_KEY",
  "NOT_A_CLEAN_IMAGE_OF_THIS_PRODUCT",
  "TOO_FEW",
  "BELOW_MIN",
  "INVALID",
  "INVALID_HS_PREFIX",
  "TOO_SHORT",
  "NOT_A_CATEGORY",
  "HAS_CHILDREN",
  "HAS_PRODUCTS",
  "ACTIVE_CHILDREN",
  "OWN_DESCENDANT",
  "PARENT_IS_LEAF",
  "PARENT_RETIRED",
  "NOT_THE_BRANCH_KIND",
  "KEY_IN_USE",
  "OPTION_IN_USE",
  "TYPE_IN_USE",
]);

/** The field issues of a `VALIDATION_FAILED` answer from a catalog route, or undefined for any other problem. */
export function issuesOf(problem: unknown): FieldIssues | undefined {
  const { code, errors } = (problem ?? {}) as { code?: string; errors?: { path: string; message: string }[] };
  if (code !== "VALIDATION_FAILED" || errors === undefined || errors.length === 0) return undefined;
  return Object.fromEntries(errors.map((error) => [error.path.replace(/^body\./, ""), error.message]));
}

/** A catalog rule's message in the reader's language; a schema message the API wrote in English reads generically. */
export function issueText(t: Translate, code: string | undefined): string | undefined {
  if (code === undefined) return undefined;
  return t(CODES.has(code) ? `catalog.issues.${code}` : "catalog.issues.invalid");
}
